export enum ENUM__settings_user_tab {
  ACCOUNT = 'account',
  BILLING = 'billing',
  COLLECTIONS = 'collections',
  CONFIRMATION_OF_ACTIONS = 'confirmation_of_actions',
  GENERATION = 'generation',
  REGIONAL = 'regional',
  UI = 'ui',
}
